import { get } from "../../data/api";

export async function getAdminStats() {
    return await get("userprofile/stats");
}
